const OrderStatus = {
    NEW: 'new',
    IN_PROGRESS: 'in progress',
    OTW: 'on the way',
    PICKING_UP: 'picking up',
    COMPLETED: 'completed',
    REJECT: 'reject',
    FAILED: 'failed',
    NO_SHOW_CANCELLED: 'no show cancelled',
    LATE_CANCELLED: 'late cancelled',
}

export default OrderStatus 
